import $ from "jquery";


jQuery(() => {
    var logo = $('.solve-logo');
    var logoPos = logo.position();

    if (typeof logoPos != 'undefined') {

        $(window).on('scroll', function () {
            var scrollPos = $(window).scrollTop();

            if (scrollPos >= logoPos.top) {
                logo.removeClass('solve-logo');
                logo.addClass('solve-logo-sticky');
            } else {
                logo.removeClass('solve-logo-sticky');
                logo.addClass('solve-logo');
            }
        });
    }

    $("#solve-blade-menu").on('click', function (event) {
        event.stopPropagation();
    });

    window.openSideNavDe = function () {
        $('.menu-blade').addClass('open de').removeClass('en');
        $('.menu-blade-overlay').removeClass('overlay-hidden');
    }

    window.openSideNavEn = function () {
        $('.menu-blade').addClass('open en').removeClass('de');
        $('.menu-blade-overlay').removeClass('overlay-hidden');
    }

    $('.menu-blade').on('click', () => {
        $('.menu-blade').removeClass('open');
        $('.menu-blade-overlay').addClass('overlay-hidden');
    });

    $('#solve-menu-blade-close').on('click', () => {
        $('.menu-blade').removeClass('open');
        $('.menu-blade-overlay').addClass('overlay-hidden');
    });

    $('.solve-horizontal-slider .container-posts > div').each(function () {
        const slider = this;
        const $slider = $(this);

        let isDown = false;
        let startX;
        let scrollLeft;

        $slider.on('mousedown', (e) => {
            e.preventDefault();
            isDown = true;
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });
        $slider.on('mouseleave', () => {
            isDown = false;
        });
        $slider.on('mouseup', () => {
            isDown = false;
        });
        $slider.on('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const moveIt = (x - startX);
            slider.scrollLeft = scrollLeft - moveIt;
        });
    });

    $('.solve-horizontal-slider .slider-itembox').each(function () {
        const slider = this;
        const $slider = $(this);

        let isDown = false;
        let startX;
        let scrollLeft;

        $slider.on('mousedown', (e) => {
            e.preventDefault();
            isDown = true;
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });
        $slider.on('mouseleave', () => {
            isDown = false;
        });
        $slider.on('mouseup', () => {
            isDown = false;
        });
        $slider.on('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const moveIt = (x - startX);
            slider.scrollLeft = scrollLeft - moveIt;
        });
    });

    $('.solve-staff-slider .container-posts.container-post-custom-layout .post-custom-layout').each(function () {
        const slider = this;
        const $slider = $(this);

        let isDown = false;
        let startX;
        let scrollLeft;

        $slider.on('mousedown', (e) => {
            e.preventDefault();
            isDown = true;
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });
        $slider.on('mouseleave', () => {
            isDown = false;
        });
        $slider.on('mouseup', () => {
            isDown = false;
        });
        $slider.on('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const moveIt = (x - startX);
            slider.scrollLeft = scrollLeft - moveIt;
        });
    });

});